module.exports = __webpack_public_path__ + "img/lang_cn.6fabca64.svg";